import { useEffect, useState } from "react";


export const formatDate = (dateString) => {
    const date = new Date(dateString); // dateString is in YYYY-MM-DD format
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};


export const formatDateReverse = (dateString) => {
    // Replace all '-' with '/' to standardize the delimiter
    const standardizedDate = dateString.replace(/-/g, '/');
    const [day, month, year] = standardizedDate.split('/');
    return `${year}-${month}-${day}`;
};



export const fetchCustTypes = async () => {
    try {
        const response = await fetch("https://api.neelakantaassociates.com/api/list-customertypes");
        if (!response.ok) throw new Error("Failed to load customer types");

        const data = await response.json();


        const sorted = [
            ...new Set(
                data
                    .map(t => t.customer_type)
                    .filter(Boolean)
                    .map(t => t.trim())
            )
        ].sort((a, b) => a.localeCompare(b));

        return sorted;
    } catch (err) {
        console.error("Error fetching customer types:", err);
        return [];
    }
};









// Function for states and districts type
const STATES_API =
    "https://api.neelakantaassociates.com/api/list-states";

const DISTRICTS_API =
    "https://api.neelakantaassociates.com/api/list-districts";

export const useStateDistrict = () => {
    const [statesList, setStatesList] = useState([]);
    const [districtsList, setDistrictsList] = useState([]);

    const [stateId, setStateId] = useState("");
    const [district, setDistrict] = useState("");

    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);

    /* Fetch states */
    useEffect(() => {
        const fetchStates = async () => {
            try {
                setLoadingStates(true);
                const response = await fetch(STATES_API);
                const data = await response.json();
                setStatesList(data);
            } catch (error) {
                console.error("Error fetching states:", error);
            } finally {
                setLoadingStates(false);
            }
        };

        fetchStates();
    }, []);



    // If you want default state from API
    // useEffect(() => {
    //   if (statesList.length > 0) {
    //     setState(statesList[0].state_name); // or state_code
    //   }
    // }, [statesList]);



    /* Fetch districts when state changes */
    useEffect(() => {
        if (!stateId) {
            setDistrictsList([]);
            setDistrict("");
            return;
        }

        const fetchDistricts = async () => {
            try {
                setLoadingDistricts(true);
                const response = await fetch(
                    `${DISTRICTS_API}?state_id=${stateId}`
                );
                const data = await response.json();
                setDistrictsList(data);
            } catch (error) {
                console.error("Error fetching districts:", error);
            } finally {
                setLoadingDistricts(false);
            }
        };

        fetchDistricts();
    }, [stateId]);

    return {
        statesList,
        districtsList,
        stateId,
        setStateId,
        district,
        setDistrict,
        loadingStates,
        loadingDistricts,
    };
};




/* ---------------- Consignment Types ---------------- */
export const useConsignmentTypes = () => {
    const [consignmentTypes, setConsignmentTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);

        fetch("https://api.neelakantaassociates.com/api/list-consignment-types")
            .then((res) => res.json())
            .then((data) => setConsignmentTypes(data))
            .catch((err) => {
                console.error("Failed to load consignment types", err);
                setError(err);
            })
            .finally(() => setLoading(false));
    }, []);

    return { consignmentTypes, loading, error };
};

/* ---------------- Shipping Modes ---------------- */
export const useShippingModes = () => {
    const [shippingModes, setShippingModes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);

        fetch("https://api.neelakantaassociates.com/api/list-shipping-modes")
            .then((res) => res.json())
            .then((data) => setShippingModes(data))
            .catch((err) => {
                console.error("Failed to load shipping modes", err);
                setError(err);
            })
            .finally(() => setLoading(false));
    }, []);

    return { shippingModes, loading, error };
};
